import React from 'react';
import { Calendar } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

const CANCEL_BTN_STYLE = {
  background: 'transparent',
  border: 'none',
  color: '#ef4444',
  cursor: 'pointer',
  padding: '4px 8px',
  borderRadius: '6px',
  fontSize: '0.8rem',
  fontWeight: 600,
};

const ScheduledEmailsCard = ({ scheduledList, onCancel }) => {
  const activeCount = scheduledList.filter((s) => s.status === 'scheduled').length;
  return (
    <Card className="history-card" data-testid="scheduled-emails-card">
      <CardHeader>
        <CardTitle className="email-card-title">
          <Calendar size={20} />
          Scheduled Emails ({activeCount})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {scheduledList.length === 0 ? (
          <p className="no-history">
            No scheduled emails yet. Toggle &quot;Schedule for later&quot; in the composer to queue a future send.
          </p>
        ) : (
          <div className="history-list" data-testid="scheduled-emails-list">
            {scheduledList.slice(0, 6).map((s) => (
              <div
                key={s.id}
                className="history-item"
                style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                data-testid={`scheduled-${s.id}`}
              >
                <div style={{ flex: 1 }}>
                  <div className="history-subject">{s.subject}</div>
                  <div className="history-meta" style={{ gap: '0.6rem' }}>
                    <span>{new Date(s.send_at).toLocaleString()}</span>
                    <span className={`history-status ${s.status}`}>{s.status}</span>
                    {s.recipient_type && (
                      <span style={{ opacity: 0.75 }}>→ {s.recipient_type}</span>
                    )}
                  </div>
                </div>
                {s.status === 'scheduled' && (
                  <button
                    type="button"
                    onClick={() => onCancel(s)}
                    title="Cancel this scheduled send"
                    data-testid={`cancel-scheduled-${s.id}`}
                    style={CANCEL_BTN_STYLE}
                  >
                    Cancel
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ScheduledEmailsCard;
